import React, { useState, useEffect } from 'react';
import { KTSVG, SimpleAlert } from '../../../../rbts/helpers';
import { Modal } from 'react-bootstrap-v5';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { crearProveedorService } from '../../../service/proveedores/Proveedores';
import { useObtenerPorId } from '../hooks/ProveedorHook';
import { PatternFormat } from 'react-number-format';

type Props = {
  show: boolean;
  handleClose: (updateGrid: boolean) => void;
  id_row: number;
};

const CreateModal: React.FC<Props> = ({ id_row, show, handleClose }) => {
  const [loading, setLoading] = useState(false);
  const genericSchema = Yup.object().shape({
    nombre: Yup.string().required('Campo requerido.'),
    nombre_contacto: Yup.string().required('Campo requerido.'),
    telefono: Yup.string().required('Campo requerido.'),
  });
  const { initValues } = useObtenerPorId(id_row);
  const formGeneric = useFormik({
    initialValues: initValues,
    validationSchema: genericSchema,
    enableReinitialize: true,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      try {
        await crearProveedorService(values);
        SimpleAlert('Se creó el proveedor exitosamente', 3000, 'success');
        handleClose(true);
        setLoading(false);
        formGeneric.resetForm();
      } catch (error: any) {
        if (error && error.response) {
          const { message } = error.response.data;
          SimpleAlert(message, 3000, 'error');
          setLoading(false);
        }
      }
    },
  });
  const handlePhoneNumberChange = (values: any) => {
    formGeneric.setFieldValue('telefono', values.target.value);
  };

  return (
    <Modal
      id="kt_modal_create"
      tabIndex={-1}
      aria-hidden="true"
      dialogClassName="modal-dialog modal-dialog-centered mw-650px"
      show={show}
      onHide={() => {
        formGeneric.resetForm();
        handleClose(false);
      }}
    >
      <div className="modal-content">
        <div className="modal-header">
          <h2>{id_row ? 'Editar proveedor' : 'Agregar proveedor'}</h2>
          <div
            className="btn btn-sm btn-icon btn-active-color-primary"
            onClick={() => {
              formGeneric.resetForm();
              handleClose(false);
            }}
          >
            <KTSVG
              className="svg-icon-2"
              path="/media/icons/duotune/arrows/arr061.svg"
            />
          </div>
        </div>
        <div className="modal-body mx-5">
          <form
            id="kt_modal_generic_form"
            className="form"
            action="#"
            onSubmit={formGeneric.handleSubmit}
          >
            <div
              className="d-flex flex-column pe-7"
              style={{ overflowY: 'auto', maxHeight: '65vh' }}
            >
              <div className="fv-row mb-7">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2">Nombre</label>
                  {formGeneric.touched.nombre && formGeneric.errors.nombre && (
                    <div className="fv-plugins-message-container text-danger w-100 ms-5">
                      <span role="alert">{formGeneric.errors.nombre}</span>
                    </div>
                  )}
                </div>
                <input
                  placeholder="Ingrese el nombre del proveedor"
                  {...formGeneric.getFieldProps('nombre')}
                  className="form-control mb-3 mb-lg-0"
                  type="text"
                  name="nombre"
                  autoComplete="off"
                />
              </div>
              <div className="fv-row mb-7">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2">
                    Nombre contacto
                  </label>
                  {formGeneric.touched.nombre_contacto &&
                    formGeneric.errors.nombre_contacto && (
                      <div className="fv-plugins-message-container text-danger ms-5">
                        <span role="alert">
                          {formGeneric.errors.nombre_contacto}
                        </span>
                      </div>
                    )}
                </div>
                <input
                  placeholder="Ingrese el nombre del contacto"
                  {...formGeneric.getFieldProps('nombre_contacto')}
                  className="form-control mb-3 mb-lg-0"
                  type="text"
                  name="nombre_contacto"
                  autoComplete="off"
                />
              </div>
              <div className="fv-row mb-7">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2">Teléfono</label>
                  {formGeneric.touched.telefono && formGeneric.errors.telefono && (
                    <div className="fv-plugins-message-container text-danger ms-5">
                      <span role="alert">{formGeneric.errors.telefono}</span>
                    </div>
                  )}
                </div>
                <PatternFormat
                  {...formGeneric.getFieldProps('telefono')}
                  className="form-control"
                  format="## #### ####"
                  name="telefono"
                  placeholder="Ingrese el teléfono del contacto"
                  onChange={handlePhoneNumberChange}
                />
                {/* <input
                  placeholder="Ingrese el teléfono del contacto"
                  {...formGeneric.getFieldProps('telefono')}
                  className="form-control mb-3 mb-lg-0"
                  type="text"
                  name="telefono"
                  autoComplete="off"
                /> */}
              </div>
            </div>
            <div className="text-center pt-15">
              <button
                type="reset"
                className="btn btn-light me-3"
                data-kt-users-modal-action="cancel"
                onClick={() => {
                  formGeneric.resetForm();
                  handleClose(false);
                }}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                data-kt-users-modal-action="submit"
                disabled={loading}
              >
                {!loading && (
                  <span className="indicator-label">
                    {id_row > 0 ? 'Actualizar' : 'Guardar'}
                  </span>
                )}
                {loading && (
                  <span
                    className="indicator-progress"
                    style={{ display: 'block' }}
                  >
                    Espere por favor...
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};
export { CreateModal };
